/*
slick
*/"use strict"

module.exports = "document" in global ? require("./finder") : { parse: require("./parser") }



//////////////////
// WEBPACK FOOTER
// /builds/crees/crees-wp/wp-content/themes/crees/node_modules/slick/index.js
// module id = 5
// module chunks = 0